import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  professionallevels: []
}

// getters
export const getters = {
  professionallevels: state => state.professionallevels
}

// mutations
export const mutations = {
  [types.FETCH_PROFESSIONALLEVELS_SUCCESS] (state, { professionallevels }) {
    state.professionallevels = professionallevels
  },

  [types.FETCH_PROFESSIONALLEVELS_FAILURE] (state) {
    state.professionallevels = []
  }
}

// actions
export const actions = {
  async fetchProfessionallevels ({ commit }) {
    try {
      const response = await axios.get(`/api/professionallevels`)

      commit(types.FETCH_PROFESSIONALLEVELS_SUCCESS, { professionallevels: response.data })
    } catch (error) {
      console.error(error)
      commit(types.FETCH_PROFESSIONALLEVELS_FAILURE)
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/professionallevels.js